import {Link} from "react-router-dom";
import {Button, BUTTON_COLOR, STATUS_TYPE} from "taltech-styleguide";
import "@styles/404PageStyles.css"
import { Action } from '@dirootie-web/components-types';
import { ErrorScreenImage } from "./ErrorScreenImage";
import { ButtonTT } from "../buttons";

export type ErrorScreenProps = {
  variant: STATUS_TYPE;
  status: number;
  title: string;
  message: string;
  actions?:[Action];
};
export const ErrorScreen: React.FC<any> = (props: any) => {
  const {variant, status, title, message} = props;
  console.log(props)
  return     <div className="container">
  <div className="row">
    <div className="col-md-6 align-self-center">
    <ErrorScreenImage />

    </div>
    <div className="col-md-6 align-self-center">
    <div className="col-md-6 align-self-center">
          <h1 className={'error-word'}>{status}</h1>
          <h2>{title}</h2>
          <p>{message}</p>
          <Button variant={BUTTON_COLOR.OUTLINE_SECONDARY} className="mt-4">
            <Link to={"/"}>Home</Link>
          </Button>
          {props.actions && props.actions.map((action: Action) => (<ButtonTT kind={action}/>))}
        </div>
      </div>
      </div>

    </div>
};


